import React, { useState, useEffect } from 'react';
import AdminApproveRecruiters from './AdminApproveRecruiters';
import LoginForm from './LoginForm';
import { getValidToken } from './utils/authUtils';
import nacmeLogo from './assets/nacme_logo.jpg';

const AdminWrapper = () => {
  console.log('🚀 ADMIN WRAPPER: Component is rendering');

  const [hasValidToken, setHasValidToken] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkToken = () => {
      const token = getValidToken();
      console.log('🔍 ADMIN WRAPPER: Token check result:', !!token);
      setHasValidToken(!!token);
      setIsChecking(false);
    };

    checkToken();
  }, []);

  if (isChecking) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (hasValidToken) {
    return <AdminApproveRecruiters />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
      <div className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <img
            src={nacmeLogo}
            alt="NACME Logo"
            className="h-16 w-auto mx-auto mb-4 drop-shadow"
          />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Admin Login
          </h1>
        </div>
        <LoginForm onLoginSuccess={() => window.location.reload()} />
      </div>
    </div>
  );
};

export default AdminWrapper;